// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--tW0l_","layoutWrapper":"styles-module--layoutWrapper--2S4_T","footer":"styles-module--footer--1kD5h"};